<template>
  <div class="flex flex-col h-full">
    <p class="text-sm bg-blue-100 p-4 rounded mt-2">
      <strong>ניהול חשבוניות ישירות מאפליקציית טיימאיט 🎉</strong><br />
      אתם כבר סולקים איתנו, אין יותר פשוט מזה! חשבוניות תשלח לבד לאחר ביצוע סליקה. עסקת מזומן? ביט? העברה בנקאית? הכל בלחיצת כפתור.
    </p>
    <p class="text-sm bg-yellow-100 text-center p-4 rounded mt-2 border border-yellow-300">
      <strong>דברו איתנו לחבילה הכי משתלמת שיש! 🔥</strong><br />
    </p>

    <div class="mb-6 p-4">
      <div class="flex items-start gap-2">
        <i class="pi pi-info-circle mt-0.5"></i>
        <div class="text-sm">
          <p class="font-semibold mb-1">אז איך מצטרפים:</p>
          <ul class="list-disc mr-5 space-y-1">
            <li>היכנסו למדריך <a class="underline font-medium" href="https://help.payme.io/hc/he/articles/360034107933-%D7%A9%D7%99%D7%A8%D7%95%D7%AA-%D7%97%D7%A9%D7%91%D7%95%D7%A0%D7%99%D7%95%D7%AA-%D7%90%D7%95%D7%98%D7%95%D7%9E%D7%98%D7%99%D7%95%D7%AA" target="_blank"> איך להוסיף שירות חשבוניות אוטומטיות <i class="pi pi-external-link ms-1" style="font-size: 0.75rem"/> </a></li>
            <li>היכנסו למערכת Payme שלכם <a class="underline font-medium" href="https://time-it.payme.io/system/login?lang=he-il" target="_blank"> בקישור הזה <i class="pi pi-external-link ms-1" style="font-size: 0.75rem"/></a> והוסיפו את אפליקציית החשבוניות</li>
            <li>לאחר שהשלמתם את הוספת האפליקציה המשיכו בתהליך</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="w-full mt-auto flex flex-col gap-2">
      <Button
        label="בואו נתחיל"
        style="display: flex; flex-grow: 1"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineEmits(['next']);
</script>

<style scoped lang="scss">
</style>
